<!-- eslint-disable -->
<template>
  <div class="d-flex align-items-center justify-content-center" v-if="User">
    <div class="row w-100 mx-0 auth-page">
      <div class="col-md-12 col-xl-12 mx-auto">
        <div class="card">
          <SectionLoaderView v-if="loadingRequest?.UploadMultiFilesXml" />
          <div class="row">
            <div class="col-md-12 stretch-card">
              <div class="card">
                <div class="card-body">
                  <p href="#" class="noble-ui-logo d-block mb-2">Télécharger plusieurs <span>&nbsp;fichiers
                      XML</span></p>
                  <!-- Informational Message for Client -->
                  <p class="info-message mt-4 mb-4">
                    <i>Note 1 : Assurez-vous de télécharger les fichiers XML dans le même ordre que celui de votre
                      système de
                      caisse.</i>
                  </p>
                  <p class="info-message mt-4 mb-4">
                    <i>Note 2 : Les résultats de votre fichier seront automatiquement liés au restaurant défini dans le fichier
                      XML</i>
                  </p>
                  <form @submit.prevent="uploadFiles">
                    <div class="row">

                      <div class="col-sm-12 mt-3">
                        <div class="mb-3">

                          <div class="row">
                            <div class="col-md-8">

                              <input class="p-fileupload p-fileupload-basic p-component" type="file" multiple
                                accept=".xml" @change="handleFileChange" />
                              <div v-if="errors.files" class="errors-response mt-5">
                                <p class="error">{{ errors.files }}</p>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Row -->
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="mb-3 mt-3">
                          <!-- Submit Button -->
                          <button type="submit" :disabled="uploading" class="w-100 btn btn-primary submit">
                            {{ uploading ? 'Téléchargement en cours...' : 'Télécharger les fichiers XML' }}
                          </button>


                        </div>
                      </div>
                    </div>
                    <!-- Row -->
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable -->
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, email, requiredIf, decimal, numeric, helpers, sameAs } from "@vuelidate/validators";
const { withParams } = helpers;
import Swal from 'sweetalert2'
export default {
  name: "EditprofileView",
  computed: {
    ...mapGetters({ User: "StateUser", BaseUrl: "StateBase" }),
    ...mapState(["loadingRequest"]),
  },
  mounted() {

  },
  data() {
    return {
      files: null,
      errors: {},
      uploading: false,
      maxFiles: 8000, // 🚀 Set the maximum number of files allowed
      isSaving: false, // Tracks if save is in progress
    };
  },

  methods: {

    ...mapActions(["UploadMultiFilesXml"]),
    handleFileChange(event) {
      this.files = event.target.files;
      this.errors = {}; // Reset errors

      if (!this.files || this.files.length === 0) {
        this.errors.files = "Veuillez sélectionner au moins un fichier.";
        return;
      }
      if (this.files.length > this.maxFiles) {
        this.errors.files = `Vous ne pouvez télécharger que ${this.maxFiles} fichiers au maximum.`;
        return;
      }
      for (let file of this.files) {
        if (file.type !== "text/xml") {
          this.errors.files = "Seuls les fichiers XML sont autorisés.";
          return;
        }

      }
    },
    handleBeforeUnload(event) {
      if (this.isSaving) {
        event.preventDefault();  // Prevent the native reload dialog
        event.returnValue = ''; // Required for the dialog to show
      }
    },
    async uploadFiles() {
      this.isSaving = true
      // 👉 Add beforeunload protection before request starts
      window.addEventListener('beforeunload', this.handleBeforeUnload)

      try {
        if (Object.keys(this.errors).length > 0) return; // Stop if validation failed

        if (!this.files || this.files.length === 0) {
          this.errors.files = "Veuillez sélectionner au moins un fichier.";
          return;
        }

        const formData = new FormData();
        Array.from(this.files).forEach((file) => {
          formData.append('CONTENU_FICHIER_XML', file);
        });


        this.uploading = true;




        const response = await this.UploadMultiFilesXml(formData);
        if (response == true)
          this.uploading = false;
        else
          this.uploading = false;

        this.isSaving = false // Now allow reload

      } catch (error) {
        console.error('Error saving:', error)
      } finally {
        this.isSaving = false
        // ❌ Remove the warning after save completes (success or fail)
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
      }

    },

  },
  //Vue Router navigation guard
  beforeRouteLeave(to, from, next) {
    if (this.isSaving) {
      Swal.fire({
        title: "Données en cours d'enregistrement",
        text: "Vous ne pouvez pas quitter cette page tant que l'enregistrement n'est pas terminé.",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'D\'accord',
      }).then((result) => {
        if (result.isConfirmed) {
          next(false)
        }
      })
    } else {
      next() // no blocking needed
    }
  },
  created() {
    // Add listener to block reload on page load
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },

  beforeDestroy() {
    // Clean up listener when component is destroyed
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }

};
</script>
<!-- eslint-disable -->
<style scoped>
.info-message {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 18px;
}
</style>